import { render, staticRenderFns } from "./PrivacyPolicyUae.vue?vue&type=template&id=1fbd0de0&"
import script from "./PrivacyPolicyUae.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyUae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports